<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

import { useLayout } from "@/layout/common/composables/layout";
import { useErrorHandler } from "@/composables/useErrorHandler";
import { useAuth } from "@/stores/auth";

import Button from "primevue/button";

import AppConfig from "@/layout/common/AppConfig.vue";
const route = useRoute();

const pageTitle = computed(() => route.meta.title || "Dashboard");

const { calculatedMenuMode } = useLayout();

// Auth info for header
const { user, userName, userRole } = useAuth();

// Logout handling (same behavior as ProfileDropdown)
const { handleError, handleSuccess } = useErrorHandler();
const { logout } = useAuth();

const handleLogout = async () => {
  try {
    await logout();
    handleSuccess("You have been successfully logged out.", "Logged Out");
  } catch (error) {
    handleError(error, "Logout Error");
  }
};
</script>

<template>
  <header
    :class="
      calculatedMenuMode === 'overlay' || calculatedMenuMode === 'static'
        ? 'pl-4'
        : 'pl-6'
    "
    class="md:max-h-16 py-4 pr-4 flex md:flex-row flex-col items-center justify-between gap-3 border-b"
  >
    <div class="flex items-center md:flex-1">
      <div class="font-medium md:text-base text-xl">
        {{ pageTitle }}
      </div>
    </div>

    <div class="flex items-center md:flex-row flex-col gap-4">
      <div class="flex items-center gap-4">
        <AppConfig />

        <!-- Profile -->
        <div class="hidden md:flex flex-col items-end leading-tight">
          <!-- <div class="text-sm font-medium">{{ userName || user?.username || '—' }}</div> -->
          <div class="font-medium text-muted-color">
            {{ userName || user?.username }}
            <span class="mx-1">•</span>
            {{ userRole || user?.role || "—" }}
          </div>
        </div>

        <Button
          icon="pi pi-sign-out"
          label="Logout"
          severity="secondary"
          outlined
          size="small"
          @click="handleLogout"
        />
      </div>
    </div>
  </header>
</template>
